export const FILE_TYPE = Symbol("FILE");
